<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="telephony-page-container">
    <EcsWindowManager :interactions="interactions" :minimized-windows-right-offset="96" />

    <EcsDialpad
      ref="callDialpad"
      class="ecs-telephony-dialpad"
      :show="showCallDialpad"
      :hidden="hideDialpadFab"
      :disabled="isOfflineModeEnabled"
      close-on-overlay-click
      @dialpad-closed="showCallDialpad = false"
      @dial="dial"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsWindowManager from '@/components/ecs-window-manager/EcsWindowManager';
import EcsDialpad from '@/components/ecs-dialpad/EcsDialpad';
import InteractionService from '@/services/interactionService';

export default {
  name: 'EcsTelephonyPage',

  components: {
    EcsWindowManager,
    EcsDialpad
  },

  data() {
    return {
      showCallDialpad: false,
      tab: null
    };
  },

  computed: {
    ...mapGetters('AGENT', ['agentState']),

    ...mapGetters('CONTACTS', ['getContactByEndPoint']),

    ...mapGetters('INTERACTIONS', ['getActiveTelephonyInteractions', 'getHistoricalTelephonyInteractions']),

    ...mapGetters('SETTINGS', ['isOfflineModeEnabled']),

    interactions() {
      return this.getActiveTelephonyInteractions.concat(this.getHistoricalTelephonyInteractions);
    },

    hideDialpadFab() {
      return this.agentState.isOffline;
    }
  },

  created() {
    this.$root.$on('open-dialpad-number', this.openDialpadWithOnlyNumber);
  },

  destroyed() {
    this.$root.$off('open-dialpad-number', this.openDialpadWithOnlyNumber);
  },

  methods: {
    openDialpadWithNumber(callDetails) {
      this.showCallDialpad = true;
      this.$refs.callDialpad.setBusinessProcessId(callDetails.businessProcessId);
      this.$refs.callDialpad.setValue(callDetails.destination);
    },

    openDialpadWithOnlyNumber({ number }) {
      this.showCallDialpad = true;
      this.$refs.callDialpad.setValue(number);
    },

    dial({ businessProcessId, businessProcessDID, phoneNumber }) {
      // Private interaction flag should be applied ONLY if current agent is on break state
      // BP Should not be included on private mode.
      InteractionService.startTelephonyInteraction({
        businessProcessId: this.agentState.isBreak ? undefined : businessProcessId,
        interaction: {
          destination: phoneNumber,
          externalDID: this.agentState.isBreak ? undefined : businessProcessDID,
          isPrivateInteraction: this.agentState.isBreak
        }
      })
        .then(response => {
          if (response.data) {
            return;
          }

          const error = response.error && response.error.message;
          this.showDialError(phoneNumber, error);
        })
        .catch(error => {
          this.showDialError(phoneNumber, error);
        });
    },

    showDialError(destination, error) {
      const errorMessage = `${this.$t('messages.unableToCall')} ${destination} ${this.$t('messages.atThisTime')}`;
      this.$root.$emit('snackbar-message', { message: errorMessage, type: 'error' });
    }
  }
};
</script>

<style>
.ecs-telephony-dialpad .ecs-dialpad-overlay {
  height: calc(100% - 48px);
}

.telephony-page-container {
  height: 100%;
  width: 100%;
}

.ecs-telephony-dialpad .ecs-dialpad {
  right: 16px;
  bottom: 150px;
  transform: none;
}
</style>
